import { FC } from 'react';
import { FooterContainer } from '../modules/footer/footer.container';
import { JourneyContainer } from '../modules/journey/journey.container';

export const Journey: FC = () => (
  <>
    <JourneyContainer />
    <FooterContainer />
  </>
);
